


















import Vue from 'vue'
import Component from 'vue-class-component'
import { State, Mutation, Action } from 'vuex-class'

@Component
export default class DeleteSelectionConfirm extends Vue {
    @State(state => state.media.showDeleteConfirmModal)
    public modalVisibility: boolean

    @State(state => state.media.selectedObjects)
    public selection: number[]

    @State(state => state.media.deletingSelection)
    public deletingSelection: boolean

    @Mutation('media/selection/delete/confirm/show')
    public showDeleteSelectionConfirm: (show: boolean) => void

    @Action('media/object/selection/delete')
    public deleteSelection: () => Promise<any>

    get message (): string {
        const length = this.selection.length

        return length < 1 ? `eliminará ${length} elemento` : `eliminarán ${length} elementos`
    }
}
